import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import { HStack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var StyledCardAction = styled(Box)(variant({
  variants: {
    left: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    right: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    center: {
      margin: "auto",
      width: "75%"
    },
    fullwidth: {
      width: "100%"
    }
  }
}));
StyledCardAction.defaultProps = {
  width: "100%"
};
var CardTextAction = function CardTextAction(_a) {
  var actionText = _a.actionText,
    icon = _a.icon,
    _b = _a.color,
    color = _b === void 0 ? "inherit" : _b;
  return React__default.createElement(HStack, {
    spacing: "6px"
  }, React__default.createElement(Paragraph, {
    size: "sm",
    color: color
  }, actionText), icon);
};
var CardAction = function CardAction(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? "fullwidth" : _b,
    actionText = _a.actionText,
    icon = _a.icon,
    color = _a.color,
    button = _a.button,
    children = _a.children,
    rest = __rest(_a, ["variant", "actionText", "icon", "color", "button", "children"]);
  return React__default.createElement(StyledCardAction, __assign({
    variant: variant
  }, rest), actionText ? React__default.createElement(CardTextAction, {
    actionText: actionText,
    icon: icon,
    color: color
  }) : children || button);
};
export { CardAction };